import { useSyncExternalStore } from "react";
import {
    ColorScheme,
    ColorSchemePreference,
    getColorSchemeSnapshot,
    nextColorSchemePreference,
    setColorSchemePreference,
    subscribeColorScheme,
} from "../theme/colorScheme";

/** The device's appearance choice and the scheme in effect (GOD-61). */
export function useColorScheme(): {
    preference: ColorSchemePreference;
    scheme: ColorScheme;
    cyclePreference: () => void;
} {
    const snapshot = useSyncExternalStore(subscribeColorScheme, getColorSchemeSnapshot);
    const [preference, scheme] = snapshot.split(":") as [ColorSchemePreference, ColorScheme];
    return {
        preference,
        scheme,
        cyclePreference: () => setColorSchemePreference(nextColorSchemePreference(preference)),
    };
}
